import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetslipError } from '../betslip-error';
import { NotifyUserErrorMixin } from '../notify-user-error';
import { ResultError } from './result-error';

export class OpenDateNotReached extends NotifyUserErrorMixin<ResultError, typeof ResultError>(ResultError) {
    constructor(pickId: string, date: string | Date | undefined) {
        super(pickId);
        if (date) {
            this.openDate = date instanceof Date ? date : new Date(date);
        }
        this.priority = -1000;
        this.hasClientValidation = true;
        this.type = PlacementErrorType.OpenDateNotReached;
    }

    readonly openDate: Date | null = null;

    override equals(error: BetslipError): boolean {
        return (
            error instanceof OpenDateNotReached &&
            error.pickId === this.pickId &&
            error.openDate != null &&
            this.openDate != null &&
            error.openDate.valueOf() === this.openDate.valueOf()
        );
    }
}
